(function($) {
	"use strict";

	// Course Progress Tracking
    //===========================================
	var courseTracking = function() {
		var courseId;
		var totalEpisodes;
		var cookie;

		var initialSetup = function() {
			setWatchedCounter();
			markEpisodesAsWatched();
			setNextEpisode();
		}

		var update = function( episodeId ) {
			// Update course progress when audio or video is played

			// Check if episode has been watched before
			if ( $.inArray( episodeId, cookie.episodes ) !== -1  ) {
				return;
			}
			cookie.episodes.push( episodeId );
			setCookie( courseId, JSON.stringify( cookie ) );
			initialSetup();
		}

		var setWatchedCounter = function() {
			var $counter = $('#completed-episodes');
			var numberWatched = cookie.episodes.length;
			$counter.text(numberWatched);
		}

		var markEpisodesAsWatched = function() {
			$.each( cookie.episodes, function( i, val ) {
				$('.course-episode[data-episode-id="' + val + '"]').addClass('completed');
			});
		}

		var setNextEpisode = function() {
			var episodes = cookie.episodes.sort();
			var nextEpisode = 0;

			for ( var i = 0; i < totalEpisodes; i++ ) {
				var val = i + 1;
				if ( val !== episodes[i] ) {
					nextEpisode = val;
					break;
				}
			}

			if ( nextEpisode === 0 ) {
				$('#current-episode').html('').append('<p>Congratulations, you have completed the course!</p>');
			} else {
				var $episode = $('.course-episode[data-episode-id="' + nextEpisode + '"]');
				var title = $episode.find('.title-text').text();
				var text = 'Up Next: Episode ' + nextEpisode + ' <br> ' + title;
				$('#current-episode').html('').append('<p>' + text + '</p>');
			}
		}

		var getCookie = function( name ) {
			var cookies = decodeURIComponent( document.cookie );
			var cookiesArray = cookies.split(';');

			for (var i = 0; i < cookiesArray.length; i++) {
				var nameValueString = cookiesArray[i].trim();
				if ( nameValueString.indexOf(name) == 0 ) {
					return nameValueString.substring(name.length + 1, nameValueString.length);
				}
			}

			return undefined;
		}

		var setCookie = function( name, value, exdays ) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires="+d.toUTCString();
			document.cookie = name + "=" + value + ";" + expires + ";path=/";
		}

		return {
			init: function() {
				if ( !$('#course-progress').length  ) {
					return; // we are not logged in
				}

				courseId = $('#course-progress').data('course-id');
				totalEpisodes = $('#course-progress').data('episodes');

				if ( !getCookie( courseId ) ) {
					// First time logged in, set cookie to no episodes watched
					cookie = {"episodes":[]};
					setCookie( courseId, JSON.stringify( cookie ) );
				} else {
					// Not the first time, get cookie
					cookie = JSON.parse( getCookie( courseId ) );
				}

				// Once we have the cookie update course progress
				initialSetup();

				// Setup listener for video or audio playing
				this.bind();
			},
			bind: function() {
				// Listen for video or audio playing and update
				$( document ).on('courseVideoPlay courseAudioPlay', function( e, course, episode ) {
					var episodeId = episode;
					update( episodeId );
				});
			},
			getCourseId: function() {
				return courseId;
			}
		}
	}

	var trackProgress = courseTracking();
	trackProgress.init();


	// Media Modal
    //===========================================
	$('#multimedia-modal').on('show.bs.modal', function (e) {
		var $modal = $(this);
		var $btn = $(e.relatedTarget);
		var modalClass = $btn.data('modal-type');

		// Check for youtube video
		if ( $btn.data('ytid') ) {
			var ytId = $btn.data('ytid');

			var ytTemplate = '<div class="embed-responsive embed-responsive-16by9">';
			ytTemplate += '<iframe class="embed-responsive-item" src="https://www.youtube.com/embed/' + ytId + '?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>'
			ytTemplate += '</div>';

			$modal.find('.modal-body').append( ytTemplate );

			$( document ).trigger( 'courseTrailerPlay', [trackProgress.getCourseId()] );
		}

		// Check for vimeo video
		if ( $btn.data('vimeo') ) {
			var vimeoId = $btn.data('vimeo');
            var vimeoTemplate = '<div class="video-wrapper"><div id="vimeo-player"></div></div>';
            $modal.find('.modal-body').append(vimeoTemplate);

            new Vimeo.Player('vimeo-player', {
                id: vimeoId,
                autoplay: true,
                byline: false,
                portrait: false,
                title: false,
                color: ''
            });
		}

        var audio = $btn.data('audio');
        if (audio) {
            var audioUrl = audio;

            var audioTemplate = '<audio id="audio-player" controls>';
            audioTemplate += '<source src="' + audioUrl + '" type="audio/mpeg">';
            audioTemplate += '</audio>';

            $modal.find('.modal-body').append(audioTemplate);
            $('#audio-player').get(0).play();
        }
	});

	$('#multimedia-modal').on('hide.bs.modal', function (e) {
		var $modal = $(this);
		$modal.find('.modal-body').html('');
	});


	// Course Audio Player
    //===========================================
    $('a[data-play-audio]').on('click', function(e) {
    	e.preventDefault();

    	var $episode = $(this).parents('.course-episode');
    	var episodeId = $(this).data('play-audio');
		var $player = $episode.find('.mejs-audio audio');
		var $playerWrapper = $player.parents('.audio-player-wrapper');
		$playerWrapper.css({'display':'block'});
		$player.get(0).play();

		// Emit event with episode number
		$( document ).trigger( 'courseAudioPlay', [trackProgress.getCourseId(), episodeId] );

		// Stop audio when accordian closes
		$( document ).on('accordianClose', function() {
			$player.get(0).pause();
			$playerWrapper.css({'display':'none'});
		});
    });

    	$('[data-modal-trigger]').on('click', function(e){
    		e.preventDefault();

    		console.log('vimeo refresh A');
    		setTimeout(function(){ window.__vimeoRefresh(); }, 5000);

    		var modalName = $(this).attr('data-modal-trigger');
    		var $modal = $('[data-modal=' + modalName + ']');
    		var display = $modal.css('display') == 'none' ? false : true;

    		// Check if youtube video
    		var ytId = $(this).attr('data-ytid');
    		if (ytId) {
    			var ytTemplate = '<div class="video-wrapper">';
    			ytTemplate += '<iframe src="https://www.youtube.com/embed/' + ytId + '?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>'
    			ytTemplate += '</div>';

    			$modal.children('.modal-content').append(ytTemplate);
    		}

    		// Check if regular mp4 video
    		var video = $(this).attr('data-video');
    		if (video) {
    			var videoUrl = window.location.origin + '/wp-content/themes/tikvahcenter/assets/images/daniel-deronda/videos/' + video;

    			var videoTemplate = '<video class="video-js vjs-default-skin" id="video-player">';
    			videoTemplate += ' <source src="' + videoUrl + '" type="video/mp4">';
    			videoTemplate += '</video>';

    			$modal.children('.modal-content').append(videoTemplate);

    			videojs('video-player', { "controls": true, "autoplay": true, "preload": "auto" }, function(){
    				// Player (this) is initialized and ready.
    			});
    		}

    		// Check if Vimeo video
    		var vimeo = $(this).attr('data-vimeo');
    		if (vimeo) {
    			console.log('Vimeo: ' + vimeo);

    			var vimeoTemplate = '<div class="video-wrapper"><div id="vimeo-player"></div></div>';

    			$modal.children('.modal-content').append(vimeoTemplate);

    			// console.log(vimeoTemplate);
    			// console.log($modal);

    			var vimeoPlayer = new Vimeo.Player('vimeo-player', {
    				id: vimeo,
    				autoplay: true,
    				byline: false,
    				portrait: false,
    				title: false,
    				color: ''
    			});
    			console.log('vimeo refresh B');
    			//window.__vimeoRefresh();
    		}

    		// Check if MP3
    		var audio = $(this).attr('data-audio');
    		if (audio) {
    			var audioUrl = audio;

    			var audioTemplate = '<audio id="audio-player" controls>';
    			audioTemplate += '<source src="' + audioUrl + '" type="audio/mpeg">';
    			audioTemplate += '</audio>';

    			$modal.children('.modal-content').append(audioTemplate);
    			$('#audio-player').get(0).play();
    		}



    		if ( !display ) {
    			$modal.css({'display': 'block'});

    			// Close modal if clicked on overlay
    			window.onclick = function(e) {
    				console.log('vimeo refresh');
    				//window.__vimeoRefresh();
    				/*if ( $(e.target).hasClass('course-modal') ) {

    					if ( $('#video-player').length === 1 ) {
    						videojs('video-player').dispose();
    					}

    					if ( $('#vimeo-player').length === 1 ) {
    						$('#vimeo-player').remove();
    					}

    					if ( $('#audio-player').length === 1 ) {
    						$('#audio-player').get(0).pause();
    						$('#audio-player').remove();
    					}

    					$modal.find('.video-wrapper').remove();
    					$modal.css({'display': 'none'});
    				}*/
    			}

    		} else {
    			if ( $('#video-player').length === 1  ) {
    				videojs('video-player').dispose();
    			}

    			if ( $('#vimeo-player').length === 1 ) {
    				$('#vimeo-player').remove();
    			}

    			if ( $('#audio-player').length === 1 ) {
    				$('#audio-player').get(0).pause();
    				$('#audio-player').remove();
    			}

    			$modal.find('.video-wrapper').remove();
    			$modal.css({'display': 'none'});
    		}
    	});

    // Course Guide Download
    //===========================================
    $('a[data-download-guide]').on('click', function(e) {
    	var episodeId = $(this).data('download-guide');

		// Emit event with episode number
		$( document ).trigger( 'downloadGuidebook', [trackProgress.getCourseId(), episodeId] );
    });

	// Episode Autoplay
	//===========================================
	$(document).ready(function() {
		let $episodeWrapper = $('#episodes-accordion');
		var urlParams = new URLSearchParams(window.location.search);

		if (urlParams.has('episode')) {
			var episodeValue = urlParams.get('episode');

			if ( episodeValue ) {

				$episodeWrapper.children().each( function( index, element ) {
					if (index !== (episodeValue - 1) ) {
						$(element).find( '.accordion-button' ).addClass('collapsed');
						$(element).find( '.accordion-collapse' ).removeClass('show');
					} else {
						$(element).find( '.accordion-button' ).removeClass('collapsed');
						$(element).find( '.accordion-collapse' ).addClass('show');

						$("html, body").animate({
							scrollTop: $(element).offset().top
						}, 500); // Adjust duration (in milliseconds) for animation speed

						if (urlParams.has('autoplay')) {
							$(element).find( 'button.play-btn' ).click();
						}
					}
				} );

				console.log($episodeWrapper.eq( parameterValue ).find( '.accordion-button' ));
				$episodeWrapper.eq( parameterValue ).find( '.accordion-button' ).removeClass('collapsed');
				$episodeWrapper.eq( parameterValue ).find( '.accordion-collapse' ).addClass('show');
				//$( document ).trigger( 'courseVideoPlay', [trackProgress.getCourseId(), parameterValue] );
			}
		} else {
			console.log("Parameter " + parameterName + " not found in the URL");
		}
	})


    // Google Analytics
    //===========================================
    var gaTracking = function() {

    	return {
    		bind: function() {

    			$( document ).on('courseTrailerPlay', function( e, course ) {
    				console.log('Played trailer ' + course );
				});

				$( document ).on('courseVideoPlay', function( e, course, episode ) {
					console.log('Played video ' + course + ' episode ' + episode );
				});

				$( document ).on('courseAudioPlay', function( e, course, episode ) {
					console.log('Played audio ' + course + ' episode ' + episode );
				});

				$( document ).on('downloadGuidebook', function( e, course, episode ) {
					console.log('Downloaded ' + course + ' episode ' + episode );
				});
    		}
    	}
    }().bind();

})(jQuery);
